<template>
   <div class="list-years">
      <div class="label">Metric Year:</div>
      <!--
      <input type="text" readonly :value="get_metric_years" v-on:click="show_date_picker = true">
      --->
      <!--<div class="date-picker" v-if="show_date_picker">-->
      <div class="date-picker">
         <div class="row">
            <div class="from-selector selector-wrapper">
               <div class="label">From:</div>
               <select name="from-metric-years" ref="from_year" v-model="selectedMetricYears.from.year">
                  <option v-for="(metricYear, index) in metricYears" :key="index" :value="metricYear">{{metricYear}}</option>
               </select>
               <!--
               <div v-if="show_from_month">
               <select name="from-metric-month" ref="from_month" v-model="selectedMetricYears.from.month">
                  <option v-for="(month, index) in monthList" :key="index" :value="index+1">{{month}}</option>
               </select>
               <input type="button" value="Clear Month" v-on:click="show_from_month = false;selectedMetricYears.from.month = ''">
               </div>
               <div v-if="!show_from_month" v-on:click="show_from_month = true">
                  Expand Month
               </div>
               -->
            </div>
            <div class="to-selector selector-wrapper">
               <div class="label">To:</div>
               <select name="to-metric-years" ref="to_year" v-model="selectedMetricYears.to.year">
                  <option v-for="(metricYear, index) in metricYears" :key="index" :value="metricYear">{{metricYear}}</option>
               </select>
               <!--
               <div v-if="show_to_month">
               <select name="to-metric-month" ref="to_month" v-model="selectedMetricYears.to.month">
                  <option v-for="(month, index) in monthList" :key="index" :value="index+1">{{month}}</option>
               </select>
               <input type="button" value="Clear Month" v-on:click="show_to_month = false;selectedMetricYears.to.month = ''">
               </div>
               <div v-if="!show_to_month" v-on:click="show_to_month = true">
                  Expand Month
               </div>
               -->
            </div>
         </div>
         <div class="row">
            <input type="button" v-on:click="update_date_range" value="Select">
            <!--<input type="button" v-on:click="show_date_picker = false" value="Close">-->
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name:"ListMetricYears",
   props:["metricYears","selectedMetricYears","monthList","chartIndex"],
   data() {
      return {
         show_date_picker: false,
         show_from_month: false,
         show_to_month: false
      }
   },
   computed: {
      get_metric_years: function() {
         let return_val = "";
         console.log(this.selectedMetricYears);
         return_val = this.selectedMetricYears.from.year.toString();
         if(this.selectedMetricYears.from.month != "") {
            return_val += " " + this.monthList[this.selectedMetricYears.from.month.toString()-1];
         }

         if(this.selectedMetricYears.from.year.toString() != this.selectedMetricYears.to.year.toString() || (this.selectedMetricYears.from.month.toString() != this.selectedMetricYears.to.month.toString() && this.selectedMetricYears.to.month.toString() != "")) {
            return_val += " to ";
            if(this.selectedMetricYears.to.year.toString() != this.selectedMetricYears.from.year.toString()) {
               return_val += this.selectedMetricYears.to.year.toString() + " ";
            }
            if(this.selectedMetricYears.to.month.toString() !="" && (this.selectedMetricYears.from.year.toString() != this.selectedMetricYears.to.year.toString() || (this.selectedMetricYears.from.year.toString() == this.selectedMetricYears.to.year.toString() && this.selectedMetricYears.from.month.toString() != this.selectedMetricYears.to.month.toString()))) return_val += this.monthList[this.selectedMetricYears.to.month.toString()-1];
         }
         return return_val;
      }
   },
   methods: {
      changeMetricYear: function(event) {
         this.$emit("changeMetricYear",event.target.value);
      },
      update_date_range: function() {
         // let updated_date_range = {
         //    from: {
         //       year: "", month: ""
         //    },
         //    to: {
         //       year: "", month: ""
         //    }
         // }
         // updated_date_range["from"]["year"] = this.$refs["from_year"].value;
         // updated_date_range["to"]["year"] = this.$refs["to_year"].value;
         // if(this.show_from_month) updated_date_range["from"]["month"] = this.$refs["from_month"].value;
         // if(this.show_to_month) updated_date_range["to"]["month"] = this.$refs["to_month"].value;
         // console.log(updated_date_range);

         //this.$emit("changeMetricDateRange",updated_date_range);
         this.$emit("changeMetricDateRange", {"chartIndex":this.chartIndex,"selectedMetricYears":this.selectedMetricYears});
         this.show_date_picker = false;
      }
   }
}
</script>

<style lang="scss">
   .list-years {
      /*width: 200px;*/
      /*margin: auto;*/
      padding-left: 0;
      .label {
         font-weight: bold; text-transform: uppercase; color: #000; margin-top: 0.5em;display: block; text-align: left;
      }
      .selector-wrapper {
         display: flex;
         .label {width: 55px; text-align: left;}
         padding-bottom: 1em;
      }
      .date-picker {
         /*position: absolute;*/
         /*margin: auto;*/
         padding: 1em;
         /*background: #fff;*/
         /*width: 200px;*/
      }
   }
</style>